var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none']},[_c('FormUserSelect',_vm._b({attrs:{"value":_vm.normalizedValue},on:{"input":_vm.update}},'FormUserSelect',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }